import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'atm', label: 'Atmospheres' },
  { key: 'lbs', label: 'lbs / in²' },
  { key: 'ihg', label: 'in Hg' },
  { key: 'mhg', label: 'mm Hg' },
  { key: 'ton', label: 'ton / in²' },
];

// Base: atmosphere
const factors = {
  atm: 1,
  lbs: 14.696,
  ihg: 29.921,
  mhg: 760,
  ton: 0.0010169093074024,
};

export const ConvPressure = () => (
  <UnitConverter
    title="Pressure"
    units={units}
    factors={factors}
    explanationTitle="Units of pressure"
    explanation="1 lb / in² = 0.068 bar. The English system's lb per square inch is approximately 0.068 times the atmospheric pressure in bar (metric system)."
  />
);
